{
    "c3d_K": {
        "key": "c3d_K",
        "isDead": false,
        "position": {
            "x": 5,
            "y": 3,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "hammer",
        "effects": {},
        "inventory": {
            "items": {}
        }
    }
}